// could add more brands and then add angle info
import {SpeakerType} from "../model/RoomConfigContext";

export const AudioConfig = {
    klipsch: {
        id: "klipsch",
        name: "Klipsch",
        // normal can be built in or not, waterfall must be built in
        type: SpeakerType.Normal,
        ceiling: {
            gltf: "assets/models/Klipsch_PRO180RPC001/Klipsch_PRO180RPC_001.gltf",
            // the dimensions of the speaker [w, h, d]
            size: [ 27.3, 11.5, 27.3 ],
            // the offset in cm to the cone [x, y, z]
            speakerOffset: [0, 2, 0],
            // the speakers point down towards the listener
            down: true,
            // the cone angles
            innerAngle: 65,
            outerAngle: 102,
            // the room needed for a fake wall to build in this speaker
            wallDepth: 0
        },
        front: {
            gltf: "assets/models/Klipsch_RP8000F001/Klipsch_RP8000F_001.gltf",
            size: [ 27.7, 109.5, 44.6 ],
            speakerOffset: [0, 75, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 50
        },
        center: {
            gltf: "assets/models/Klipsch_RP504C001/Klipsch_RP504C_001.gltf",
            size: [ 79.1, 17.3, 36.7 ],
            speakerOffset: [0, 8.5, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 37
        },
        surround: {
            gltf: "assets/models/Klipsch_RRP600M001/Klipsch_RP600M_001.gltf",
            size: [ 20.2, 39.8, 30.1 ],
            speakerOffset: [0, 10, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 31
        },
        subwoofer: {
            gltf: "assets/models/Klipsch_SPL100001/Klipsch_SPL100_001.gltf",
            size: [ 35.6, 42.1, 45.1 ],
            speakerOffset: [0, 20, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 46
        },
        url: "https://www.cinedream.be/artikelgroep/klipsch-reference-premiere"
    },
    waterfall: {
        id: "waterfall",
        name: "Waterfall",
        // normal can be built in or not, waterfall must be built in
        type: SpeakerType.Waterfall,
        ceiling: {
            gltf: "assets/models/Waterfall_HurrEvo/WF_HURREVO_001.gltf",
            // the dimensions of the speaker [w, h, d]
            size: [ 27.3, 11.5, 27.3 ],
            // the offset in cm to the cone [x, y, z]
            speakerOffset: [0, 0, 0],
            fixedPosition: [0, 100, 0],
            // the speakers point down towards the listener
            down: true,
            // the cone angles
            innerAngle: 65,
            outerAngle: 102,
            // the room needed for a fake wall to build in this speaker
            wallDepth: 0
        },
        front: {
            gltf: "assets/models/Waterfall_LCR300/WF_LCR300_001.gltf",
            size: [ 57, 43, 20.4 ],
            speakerOffset: [0, 21.5, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 20.4
        },
        center: {
            gltf: "assets/models/Waterfall_LCR300/WF_LCR300_001.gltf",
            size: [ 57, 43, 20.4 ],
            speakerOffset: [0, 21.5, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 20.4
        },
        surround: {
            gltf: "assets/models/Waterfall_SAT150/WF_SAT150_001.gltf",
            size: [ 57, 43, 9.8 ],
            speakerOffset: [0, 21.5, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 9.8
        },
        subwoofer: {
            gltf: "assets/models/Waterfall_SUB600S/WF_SUB600S_001.gltf",
            size: [ 57, 87.5, 19.7 ],
            speakerOffset: [0, 43.75, 0],
            innerAngle: 55,
            outerAngle: 86,
            wallDepth: 19.7
        },
        url: "https://www.cinedream.be/artikelgroep/waterfall-pro-custom"
    }
};
